// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#users-need-context {
  background-image: url("https://s3.g.s4.mega.io/2ijnsv4opkr3vvr6zwjtrqfdrjtysegsktpws/context-coding/public/img/laptop-stock.webp");
  background-size: cover;
}

#users-need-context h2 {
  color: var(--brand-white1);
  text-shadow: var(--text-shadow1);
}

.users-need-context-gp {
  display: flex;
  flex-direction: column;
  gap: 20px 5px;
  align-items: center;
}

.users-need-context-item-ct {
  background-color: var(--brand-white1);
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  padding: 10px;
  max-width: 900px;
  border-radius: 10px;
  border: 1px solid black;
  border-top: 1px solid var(--brand-white3);
  border-left: 1px solid var(--brand-white3);
  box-shadow: 3px 3px 3px var(--brand-white3);
}

.users-need-context-item-ct svg {
  /* min-width: 100px; */
  width: 100px;
  height: 100px;
  fill: var(--brand-blue1);
  border-bottom: 2px dotted var( --brand-red1);
}

.question-title-detail-ct {
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.question-title-detail-ct h3 {
  margin: 0;
  /* font-size: 150%; */
  font-family: var(--font-family1);
}



/* MEDIA QUERIES */
@media (max-width: 690px) {
  .question-title-detail-ct h3 {
    text-align: center;
  }
  .question-title-detail-ct p {
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/card-groups/UsersNeedContextCardGroup/UsersNeedContextCardGroup.css"],"names":[],"mappings":"AAAA;EACE,kIAAkI;EAClI,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,gCAAgC;AAClC;;;;AAIA,kBAAkB;AAClB;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["#users-need-context {\n  background-image: url(\"https://s3.g.s4.mega.io/2ijnsv4opkr3vvr6zwjtrqfdrjtysegsktpws/context-coding/public/img/laptop-stock.webp\");\n  background-size: cover;\n}\n\n#users-need-context h2 {\n  color: var(--brand-white1);\n  text-shadow: var(--text-shadow1);\n}\n\n.users-need-context-gp {\n  display: flex;\n  flex-direction: column;\n  gap: 20px 5px;\n  align-items: center;\n}\n\n.users-need-context-item-ct {\n  background-color: var(--brand-white1);\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  align-items: center;\n  padding: 10px;\n  max-width: 900px;\n  border-radius: 10px;\n  border: 1px solid black;\n  border-top: 1px solid var(--brand-white3);\n  border-left: 1px solid var(--brand-white3);\n  box-shadow: 3px 3px 3px var(--brand-white3);\n}\n\n.users-need-context-item-ct svg {\n  /* min-width: 100px; */\n  width: 100px;\n  height: 100px;\n  fill: var(--brand-blue1);\n  border-bottom: 2px dotted var( --brand-red1);\n}\n\n.question-title-detail-ct {\n  max-width: 500px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.question-title-detail-ct h3 {\n  margin: 0;\n  /* font-size: 150%; */\n  font-family: var(--font-family1);\n}\n\n\n\n/* MEDIA QUERIES */\n@media (max-width: 690px) {\n  .question-title-detail-ct h3 {\n    text-align: center;\n  }\n  .question-title-detail-ct p {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
